// @view/panels/document/review/SectionTitleError.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import type { VisibilityPhase } from "@ps-bridge/models/ui/visibilityPhase";
import SectionTitleErrorView from "@view/document/review/SectionTitleError.view";

type SectionTitleErrorPanelProps = {
  phase: VisibilityPhase;
  message: string;
};

const SectionTitleErrorPanel: React.FC<SectionTitleErrorPanelProps> = ({ phase, message }) => {
  const phaseKeys = {
    hidden: "hidden",
    visible: "visible",
  } as const satisfies Record<VisibilityPhase, VisibilityPhase>;

  const render = {
    [phaseKeys.hidden]: <EmptyView />,
    [phaseKeys.visible]: <SectionTitleErrorView sectionTitleErrorMessage={message} />,
  } as const satisfies Record<VisibilityPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(SectionTitleErrorPanel, (prevProps, nextProps) => {
  return prevProps.phase === nextProps.phase;
});
